export default {
    BUTTON_ADD: "Pridaj aj ty komentár",
    BUTTON_EXPAND: "Zobraziť reakcie (+%count%)",
    BUTTON_HIDE_0: "Skryť komentáre",
    BUTTON_HIDE_1: "Skryť 1 komentár",
    BUTTON_HIDE_2: "Skryť %count% komentáre",
    BUTTON_HIDE_3: "Skryť %count% komentárov",
    BUTTON_SHOW_0: "Buď prvý a pridaj komentár",
    BUTTON_SHOW_0_SHORT: "Pridaj komentár",
    BUTTON_SHOW_1: "Zobraziť 1 komentár",
    BUTTON_SHOW_1_SHORT: "1 komentár",
    BUTTON_SHOW_2: "Zobraziť %count% komentáre",
    BUTTON_SHOW_2_SHORT: "%count% komentáre",
    BUTTON_SHOW_3: "Zobraziť %count% komentárov",
    BUTTON_SHOW_3_SHORT: "%count% komentárov",
    COMMENT_AUTHOR: "Autor článku",
    COMMENT_BLOCKED: "Komentár bol odstránený pre nevhodný obsah a porušenie",
    COMMENT_BLOCKED_LINK: "Komunitných pravidiel Refresheru",
    COMMENT_EDITOR: "Redaktor",
    COMMENT_EXTEND: "Zobraziť celý komentár",
    FORM_PLACEHOLDER: "Vyjadri svoj názor aj ty …",
    FORM_SUBMIT: "Odoslať",
    MODAL_BUTTON_BLOCK: "Zablokovať",
    MODAL_BUTTON_CANCEL: "Zrušiť",
    MODAL_BUTTON_DELETE: "Odstrániť",
    MODAL_BUTTON_LOGIN: "Prihlásiť sa",
    MODAL_BUTTON_OK: "OK",
    MODAL_BUTTON_PREMIUM: "Predplatiť",
    MODAL_BUTTON_REPORT: "Nahlásiť",
    MODAL_BUTTON_VERIFY: "Overiť účet",
    MODAL_TEXT_BLOCK: "Naozaj chceš zablokovať tento komentár?",
    MODAL_TEXT_DELETE: "Naozaj chceš odstrániť svoj komentár?",
    MODAL_TEXT_ERROR_1: "Nepodarilo sa načítať dáta pre diskusiu. Skúste znova načítať stránku.\n\n" +
        "V prípade že problémy pretrvávajú, kontaktuje prosím administrátora.",
    MODAL_TEXT_ERROR_2: "Pri pridávani komentára nastala chyba. Skúste sa nanovo prihlásiť a znova " +
        "odoslať komentár.\n\nV prípade že problémy pretrvávajú, kontaktuje prosím administrátora.",
    MODAL_TEXT_ERROR_3: "Pri hodnotení komentára nastala chyba. Skúste sa nanovo prihlásiť a znova " +
        "ohodnotiť komentár.\n\nV prípade že problémy pretrvávajú, kontaktuje prosím administrátora.",
    MODAL_TEXT_ERROR_4: "Pri nahlasení komentára nastala chyba. Skúste znova načítať stránku.\n\n" +
        "V prípade že problémy pretrvávajú, kontaktuje prosím administrátora.",
    MODAL_TEXT_ERROR_5: "Pri odstraňovaní komentára nastala chyba. Skúste sa nanovo prihlásiť a znova " +
        "odstraniť komentár.\n\nV prípade že problémy pretrvávajú, kontaktuje prosím administrátora.",
    MODAL_TEXT_ERROR_6: "Nepodarilo sa zablokovať komentár. Skús sa nanovo prihlásiť a znova " +
        "zablokovať komentár.\n\nV prípade že problémy pretrvávajú, kontaktuj prosím administrátora.",
    MODAL_TEXT_LOGIN_1: "Musíš byť prihlásený/á , aby si mohol pridať komentár.",
    MODAL_TEXT_LOGIN_2: "Musíš byť prihlásený/á , aby si mohol ohodnotiť komentár.",
    MODAL_TEXT_PREMIUM: "Musíš mať predplatené REFRESHER+, aby si mohol pridať komentár.",
    MODAL_TEXT_REPORT_1: "Naozaj chceš nahlásiť tento komentár?",
    MODAL_TEXT_REPORT_2: "Ďakujeme, komentár bol nahlásený.",
    MODAL_TEXT_VERIFY: "Komentár, ktorý si pridal, vidíš zatiaľ len ty. Pre zobrazenie komentárov ostatným používateľom je potrebné overiť tvoj účet.",
    REPLY_BUTTON: "Odpovedať",
    REPLY_PLACEHOLDER: "Reagovať ...",
    REPLY_SUBMIT: "Odoslať",
    SORT_RATING: "od najoblúbenejších",
    SORT_TIMESTAMP: "od najnovších",
    TOOLTIP_BLOCK: "Zablokovať komentár",
    TOOLTIP_DELETE: "Odstrániť komentár",
    TOOLTIP_REPORT: "Nahlásiť komentár",
    TOOLTIP_PREMIUM: "Predplatiteľ REFRESHER+",
    UNVERIFIED_TITLE: "Komentár pridaný od neovereného používateľského účtu.",
    UNVERIFIED_TEXT_1: "Po",
    UNVERIFIED_TEXT_2: "overení",
    UNVERIFIED_TEXT_3: "zo strany používateľa sa komentár zobrazí.",
};